var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 77,
    rx: 15,
    fill: "url(#paint0_linear_344_153)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3333 54V50.6667C47.3333 48.8986 46.6309 47.2029 45.3807 45.9526C44.1304 44.7024 42.4347 44 40.6666 44H27.3333C25.5652 44 23.8695 44.7024 22.6192 45.9526C21.369 47.2029 20.6666 48.8986 20.6666 50.6667V54",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37.3333C37.6819 37.3333 40.6667 34.3486 40.6667 30.6667C40.6667 26.9848 37.6819 24 34 24C30.3181 24 27.3334 26.9848 27.3334 30.6667C27.3334 34.3486 30.3181 37.3333 34 37.3333Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3334 54.0001V50.6668C57.3323 49.1897 56.8406 47.7548 55.9356 46.5873C55.0307 45.4199 53.7636 44.5861 52.3334 44.2168",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6666 24.2168C47.1007 24.584 48.3717 25.418 49.2794 26.5873C50.187 27.7567 50.6797 29.1948 50.6797 30.6751C50.6797 32.1554 50.187 33.5936 49.2794 34.7629C48.3717 35.9323 47.1007 36.7663 45.6666 37.1335",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_153",
    x1: 5.5,
    y1: 5,
    x2: 71.5,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2485FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.fdb1da1a60acc9bb8c53da0d594b623f.svg";
export { ForwardRef as ReactComponent };